import { call, select } from 'redux-saga/effects'
import { AuthSelectors } from 'Redux/AuthRedux'

export function * onStartup (api, action) {
  const authData = yield select(AuthSelectors.authData)
  if (authData['access-token']) {
    yield call(api.setAuthData, authData)
  }
}



// WEBPACK FOOTER //
// ./src/Sagas/StartupSagas.js